import TradeInDetails from './TradeInDetails';

export default TradeInDetails;
